import { useT, type TKey } from './i18n';

const KNOWN = new Set([
  'INVALID_EMAIL_OR_PASSWORD',
  'INVALID_PASSWORD',
  'PASSWORD_TOO_SHORT',
  'USER_ALREADY_EXISTS',
  'INVALID_CODE',
  'INVALID_BACKUP_CODE',
  'TOO_MANY_ATTEMPTS',
  'ACCOUNT_TEMPORARILY_LOCKED',
  'INVALID_TWO_FACTOR_COOKIE',
  'SESSION_NOT_FRESH',
  'INVALID_TOKEN',
  'TOO_MANY_REQUESTS',
]);

type AuthError = { code?: string; message?: string; status?: number } | null | undefined;

/** Better Auth answers in English; this turns its error codes into our own words. */
export function useAuthError() {
  const t = useT();
  return (e: AuthError): string | null => {
    if (!e) return null;
    const code = e.status === 429 ? 'TOO_MANY_REQUESTS' : e.code?.startsWith('USER_ALREADY_EXISTS') ? 'USER_ALREADY_EXISTS' : e.code?.startsWith('TOO_MANY_ATTEMPTS') ? 'TOO_MANY_ATTEMPTS' : e.code;
    return code && KNOWN.has(code) ? t(`authErr.${code}` as TKey) : t('error.generic');
  };
}
